
(function(){
"use strict";
const SHOPIFY = window.__NEON_SHOPIFY_CONFIG__ || {
  checkoutMode:"quote_only",
  variantId:null,
  variantPriceCents:0,
  variantPriceFormatted:"",
  afterAdd:"cart",
  cartUrl:"/cart",
  draftOrderEndpoint:""
};

const fonts = [
 ["Monoton","statement","'Monoton',Impact,sans-serif"],

 ["Montserrat","modern","'Montserrat',Arial,sans-serif"],["Josefin Sans","modern","'Josefin Sans',Arial,sans-serif"],
 ["Quicksand","modern","'Quicksand',Arial,sans-serif"],["Oswald","modern","'Oswald','Arial Narrow',Arial,sans-serif"],
 ["Comfortaa","modern","'Comfortaa',Arial,sans-serif"],

 ["Dancing Script","script","'Dancing Script',cursive"],["Pacifico","script","'Pacifico',cursive"],
 ["Great Vibes","script","'Great Vibes',cursive"],["Yellowtail","script","'Yellowtail',cursive"],
 ["Kaushan Script","script","'Kaushan Script',cursive"],

 ["Playfair Display","elegant","'Playfair Display',Georgia,serif"],["Cinzel","elegant","'Cinzel',Georgia,serif"],
 ["Cormorant Garamond","elegant","'Cormorant Garamond',Georgia,serif"],["Crimson Pro","elegant","'Crimson Pro',Georgia,serif"],
 ["Italiana","elegant","'Italiana',Georgia,serif"],

 ["Bebas Neue","statement","'Bebas Neue',Impact,sans-serif"],["Anton","statement","'Anton',Impact,sans-serif"],
 ["Bungee","statement","'Bungee',Impact,sans-serif"],["Permanent Marker","statement","'Permanent Marker',cursive"]
];

fonts.unshift(...fonts.splice(fonts.findIndex(f=>f[0]==='Yellowtail'),1));

const state = {
 mode:"text",logoData:null,logoName:"",logoFormat:"",logoAspect:2.4,logoStyle:"original",lines:["DEIN NEON"],lineSpacing:12,text:"DEIN NEON",font:fonts[0][2],fontName:fonts[0][0],size:50,maxChars:10,customSize:false,sizeMode:"preset",
 colorMode:"solid",colorName:"Warmweiss",glow:"#ffb45c",core:"#fff3df",
use:"indoor",board:"contour",boardColor:"transparent",ral:"RAL 9005",ralHex:"#111111",
 mount:"wall",remote:true,smart:null,brightness:92,bg:"warm"
};



const helpContent={
 "board-none":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-none.jpg?v=1791005980",title:"Freigestellt",text:"LED-Neon-Buchstaben direkt an der Wand montiert, ohne sichtbare Rückwand."},
 "board-contour":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-contour.jpg?v=1791005980",title:"Kontur",text:"Acryl-Rückwand exakt entlang der Schriftform zugeschnitten."},
 "board-rectangle":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-rectangle.jpg?v=1791005980",title:"Rechteck",text:"Klassische rechteckige Acrylplatte hinter dem Schriftzug."},
 "board-strips":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-strips.jpg?v=1791006155",title:"Acrylstreben",text:"Wenige schmale Acrylstreben statt einer vollen Platte – luftiger Look."},
 "board-box":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-box.jpg?v=1791005981",title:"Acrylbox",text:"3D-Acrylbox, freistehend."},
 "board-stand":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/board-stand.jpg?v=1791005980",title:"Aufsteller",text:"Kleiner Tisch- oder Theken-Aufsteller."},
 "boardcolor-transparent":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-transparent.jpg?v=1791005981",title:"Transparent",text:"Klares, durchsichtiges Acryl."},
 "boardcolor-black":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-black.jpg?v=1791005980",title:"Schwarz",text:"Schwarzes Acryl für starken Kontrast."},
 "boardcolor-white":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-white.jpg?v=1791005981",title:"Weiss",text:"Weisses Acryl, clean."},
 "boardcolor-gold":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-gold.jpg?v=1791005981",title:"Gold",text:"Goldfarben verspiegeltes Acryl."},
 "boardcolor-silver":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-silver.jpg?v=1791005981",title:"Silber",text:"Silbern verspiegeltes Acryl."},
 "boardcolor-ral":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/boardcolor-ral.jpg?v=1791005980",title:"RAL-Wunschfarbe",text:"Individuelle Farbe nach RAL-Farbkarte."},
 "mount-wall":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/mount-wall.jpg?v=1791005981",title:"Wandmontage",text:"Montage mit kleinen Abstandhaltern direkt an der Wand."},
 "mount-chain":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/mount-chain.jpg?v=1791005980",title:"Kettenaufhängung",text:"Schild hängt an dünnen Ketten oder Seilen von der Decke."},
 "mount-tape":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/mount-tape.jpg?v=1791005980",title:"3M Klebestreifen",text:"Leichte Ausführungen werden mit doppelseitigem Klebeband montiert."},
 "mount-table":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/mount-table.jpg?v=1791005981",title:"Tischständer",text:"Freistehender Ständer für Tisch oder Theke."},
 "control-remote":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/help-remote-dimmer.jpg?v=1790883002",title:"Remote + Dimmer",text:"Fernbedienung zum Ein-/Ausschalten und Dimmen."},
 "control-no_remote":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/control-no_remote.jpg?v=1791005980",title:"Ohne Remote",text:"Basis-Ausführung, einfacher Stecker ohne Fernbedienung."},
 "control-smart":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/control-smart.jpg?v=1791005980",title:"Smart / Tuya",text:"Steuerung per App oder Sprachassistent."},
 "control-dali":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/help-dali-ballast.png?v=1790883001",title:"DALI",text:"DALI-Steuerung für Gewerbe und Gebäudeautomation."},
 "use-indoor":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/use-indoor.jpg?v=1791005981",title:"Innen",text:"Ausführung für den Einsatz in Innenräumen."},
 "use-outdoor":{img:"https://cdn.shopify.com/s/files/1/0943/7203/6947/files/use-outdoor.jpg?v=1791005980",title:"Aussen",text:"Wetterfeste Ausführung für den Aussenbereich."}
};
function openHelp(key){
 const c=helpContent[key];
 if(!c)return;
 q("#helpLightboxImgWrap").classList.toggle("show",!!c.img);
 q("#helpLightboxImg").src=c.img||"";
 q("#helpLightboxImg").alt=c.title;
 q("#helpLightboxTitle").textContent=c.title;
 q("#helpLightboxText").textContent=c.text;
 q("#helpLightbox").classList.add("show");
}
function closeHelp(){
 q("#helpLightbox").classList.remove("show");
}


/* ==========================================================
   V23 · Mobile guided configurator
   ========================================================== */
const wizardMedia=window.matchMedia("(max-width:760px)");
let wizardStep=1;

function wizardStepMap(){
 const steps=[
   {id:1,title:state.mode==="logo"?"Logo":"Text & Schrift"},
   {id:3,title:"Lichtfarbe"},
   {id:4,title:"Grösse"},
   {id:5,title:"Rückwand"},
   {id:6,title:"Montage"},
   {id:7,title:"Steuerung"},
   {id:8,title:"Einsatz & Masse"},
   {id:9,title:"Abschluss"}
 ];
 return steps;
}

function normalizeWizardStep(){
 const valid=wizardStepMap().map(x=>x.id);
 if(!valid.includes(wizardStep)){
   wizardStep=valid.reduce((best,n)=>Math.abs(n-wizardStep)<Math.abs(best-wizardStep)?n:best,valid[0]);
 }
}

function sectionAllowedOnCurrentStep(el){
 const step=Number(el.dataset.wizardStep);
 if(step!==wizardStep)return false;

 if(el.id==="textSection" && state.mode!=="text")return false;
 if(el.id==="fontSection" && state.mode!=="text")return false;
 if(el.id==="logoUploadSection" && state.mode!=="logo")return false;
 if(el.id==="boardColorSection"){
   return state.board==="rectangle" || state.board==="strips";
 }
 return true;
}

function applyWizardVisibility(scroll=false){
 const all=qa("[data-wizard-step]");
 if(!wizardMedia.matches){
   all.forEach(el=>el.classList.remove("wizard-active"));
   return;
 }

 normalizeWizardStep();
 all.forEach(el=>{
   el.classList.toggle("wizard-active",sectionAllowedOnCurrentStep(el));
 });

 const map=wizardStepMap();
 const index=Math.max(0,map.findIndex(x=>x.id===wizardStep));
 const current=map[index]||map[0];

 const pos=q("#wizardPosition");
 const bar=q("#wizardProgressBar");
 const prev=q("#wizardPrev");
 const next=q("#wizardNext");
 const kicker=q("#mobileStepTitle");
 const count=q("#mobileStepCount");

 if(pos)pos.textContent=`${index+1} / ${map.length} · ${current.title}`;
 if(bar)bar.style.width=`${((index+1)/map.length)*100}%`;
 if(prev)prev.disabled=index===0;
 if(next){
   next.textContent=index===map.length-1?"FERTIG":"WEITER";
   next.disabled=index===map.length-1;
 }
 if(kicker)kicker.textContent=current.title;
 if(count)count.textContent=`Schritt ${index+1} von ${map.length}`;

 if(scroll){
   const config=q(".config");
   const active=qa("[data-wizard-step].wizard-active")[0];
   if(config && active){
     const y=Math.max(0,active.getBoundingClientRect().top + window.scrollY - 315);
     window.scrollTo({top:y,behavior:"smooth"});
   }
 }
 requestAnimationFrame(()=>{fitText();updateDimensionOverlay()});
}

function moveWizard(direction){
 const map=wizardStepMap();
 normalizeWizardStep();
 const index=map.findIndex(x=>x.id===wizardStep);
 const nextIndex=Math.max(0,Math.min(map.length-1,index+direction));
 if(nextIndex===index)return;
 wizardStep=map[nextIndex].id;
 applyWizardVisibility(true);
}

function resetWizardForMode(){
 wizardStep=1;
 applyWizardVisibility(false);
}

function syncWizardAfterRender(){
 if(wizardMedia.matches)applyWizardVisibility(false);
}

wizardMedia.addEventListener?.("change",()=>applyWizardVisibility(false));

const q=s=>document.querySelector(s), qa=s=>Array.from(document.querySelectorAll(s));
const neon=q("#neonText"), stage=q("#stage"), board=q("#board"), boardLines=q("#boardLines"), wallGlow=q("#wallGlow"), mountHardware=q("#mountHardware"), logoPreviewWrap=q("#logoPreviewWrap"), logoPreview=q("#logoPreview"), logoContourPreview=q("#logoContourPreview"), logoPlaceholder=q("#logoPlaceholder"), logoGlow=q("#logoGlow"), notice=q("#notice"), measureSvg=q("#measureSvg"), dimOverlay=q("#dimOverlay"), dimWidth=q("#dimWidth"), dimHeight=q("#dimHeight"), dimWidthLabel=q("#dimWidthLabel"), dimHeightLabel=q("#dimHeightLabel");

function buildFonts(){
 q("#fontGrid").innerHTML=fonts.map((f,i)=>`<button class="font-card${i===0?" active":""}" data-font-index="${i}" data-category="${f[1]}"><span class="font-sample" style="font-family:${f[2]}">DEIN NEON</span><small>${f[0]}</small></button>`).join("");
}
buildFonts();



function setModeVisibility(){
 qa("[data-config-mode]").forEach(b=>b.classList.toggle("active",b.dataset.configMode===state.mode));
 q("#textSection").style.display=state.mode==="text"?"":"none";
 q("#fontSection").style.display=state.mode==="text"?"":"none";
 q("#logoUploadSection").style.display=state.mode==="logo"?"":"none";
 neon.style.display=state.mode==="text"?"flex":"none";
 wallGlow.style.display=state.mode==="text"?"flex":"none";
 logoPreviewWrap.style.display=state.mode==="logo"?"flex":"none";
 boardLines.style.display=state.mode==="logo"?"none":"";
}

function setConfigMode(mode){
 state.mode=mode==="logo"?"logo":"text";
 setModeVisibility();
 resetWizardForMode();
 render();
}

function logoDimensions(){
 const w=Math.round(state.size*10)/10;
 const aspect=Math.max(.10,Number(state.logoAspect)||2.4);
 return {w,h:Math.round((w/aspect)*10)/10,lines:[]};
}

function activeVisualRect(){
 if(state.mode==="logo"){
   return state.logoData ? logoPreview.getBoundingClientRect() : logoPreviewWrap.getBoundingClientRect();
 }
 return neon.getBoundingClientRect();
}

function updateLogoInfo(){
 q("#logoStatus").textContent=state.logoData?"Logo geladen":"noch kein Logo";
 q("#logoInfo").style.display=state.logoData?"grid":"none";
 q("#logoName").textContent=state.logoName||"–";
 q("#logoFormat").textContent=(state.logoFormat||"–").toUpperCase();
 q("#logoAspect").textContent=state.logoData?state.logoAspect.toFixed(2)+":1":"–";
 q("#logoNotice").textContent=state.logoData
   ?"Logo geladen. Die Breite ist das Referenzmass; die Höhe wird aus dem Seitenverhältnis berechnet."
   :"Logo auswählen. Die Datei bleibt lokal in deinem Browser.";
}

function handleLogoFile(file){
 if(!file)return;
 const ok=["image/svg+xml","image/png","image/jpeg","image/webp"];
 if(!ok.includes(file.type)){
   const toast=q("#toast");toast.textContent="Bitte SVG, PNG, JPG oder WEBP verwenden.";toast.classList.add("show");setTimeout(()=>toast.classList.remove("show"),2200);return;
 }
 const reader=new FileReader();
 reader.onload=()=>{
   const img=new Image();
   img.onload=()=>{
     state.logoData=String(reader.result);
     state.logoName=file.name;
     state.logoFormat=(file.name.split(".").pop()||file.type.split("/").pop()||"").toLowerCase();
     state.logoAspect=Math.max(.10,img.naturalWidth/Math.max(1,img.naturalHeight));
     logoPreview.src=state.logoData;
     logoContourPreview.src=state.logoData;
     updateLogoInfo();
     render();
   };
   img.onerror=()=>{
     const toast=q("#toast");toast.textContent="Logo konnte nicht gelesen werden.";toast.classList.add("show");setTimeout(()=>toast.classList.remove("show"),2200);
   };
   img.src=String(reader.result);
 };
 reader.readAsDataURL(file);
}

function getLineInputs(){return qa(".line-input")}
function syncLinesFromInputs(){
 state.lines=getLineInputs().map(x=>x.value||"").filter((x,i,a)=>x.length>0 || a.length===1);
 if(state.lines.length===0) state.lines=[""];
 state.text=state.lines.join(" / ");
}

function rebuildLinesEditor(){
 const editor=q("#linesEditor");
 editor.innerHTML=state.lines.map((line,i)=>`
  <div class="line-row" data-line-row="${i}">
   <input class="line-input" data-line="${i}" value="${String(line).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/</g,"&lt;")}" maxlength="24" autocomplete="off">
   <button class="line-remove" data-remove-line="${i}" type="button" ${state.lines.length===1?"disabled":""}>×</button>
  </div>`).join("");
 q("#lineCountHint").textContent=state.lines.length;
}

function updateLineSpacingVisibility(){
 const wrap=q("#lineSpacingWrap");
 if(!wrap)return;
 wrap.style.display=(state.mode==="text" && state.lines.length>1)?"":"none";
}

function rebuildPreviewLines(){
 const safe=line=>String(line||" ").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");

 neon.innerHTML=state.lines.map(line=>{
   const t=safe(line);
   return `<span class="neon-line"><span class="tube-aura">${t}</span><span class="tube-body">${t}</span><span class="tube-highlight">${t}</span></span>`;
 }).join("");

 wallGlow.innerHTML=state.lines.map(line=>`<span class="wall-glow-line">${safe(line)}</span>`).join("");
 boardLines.innerHTML=state.lines.map(line=>`<span class="board-line">${safe(line)}</span>`).join("");

 const gap=Math.max(2,Math.round(state.lineSpacing*.45));
 neon.style.gap=gap+"px";
 wallGlow.style.gap=gap+"px";
 boardLines.style.gap=gap+"px";
}

function cleanLen(){return state.lines.join("").trim().length}
function money(v){return "USD "+v.toFixed(2)}

function autoSize(){
 const len=cleanLen(), buttons=qa("[data-size]");

 if(state.mode==="logo"){
   buttons.forEach(b=>b.disabled=false);

   if(state.sizeMode==="manual"){
     buttons.forEach(b=>b.classList.remove("active"));
     q("#manualSizeChoice").classList.add("active");
     q("#manualSizePanel").style.display="";
   }else{
     q("#manualSizeChoice").classList.remove("active");
     q("#manualSizePanel").style.display="none";
     buttons.forEach(b=>b.classList.toggle("active",Number(b.dataset.size)===state.size));
   }

   notice.classList.remove("show");
   return;
 }

 if(state.sizeMode==="manual"){
   buttons.forEach(b=>{b.disabled=false;b.classList.remove("active")});
   q("#manualSizeChoice").classList.add("active");
   q("#manualSizePanel").style.display="";
   notice.textContent="Manuelle Breite "+state.size+" cm aktiv. S / M / L sind bewusst nicht gleichzeitig gewählt.";
   notice.classList.add("show");
   return;
 }

 q("#manualSizeChoice").classList.remove("active");
 q("#manualSizePanel").style.display="none";

 buttons.forEach(b=>b.disabled=(len>Number(b.dataset.max) && len<=16));

 if(len>16){
   buttons.forEach(x=>x.classList.remove("active"));
   const large=buttons.find(b=>Number(b.dataset.size)===80);
   if(large){large.classList.add("active");large.disabled=false}
   state.size=80;state.maxChars=16;
   notice.textContent="Mehr als 16 Zeichen: L ist die grösste Standardvariante. Für Produktion und Preis ist eine Sonderanfrage nötig.";
   notice.classList.add("show");
   return;
 }

 if(len>state.maxChars){
   const valid=buttons.find(b=>!b.disabled);
   if(valid){
     buttons.forEach(x=>x.classList.remove("active"));
     valid.classList.add("active");
     state.size=Number(valid.dataset.size);
     state.maxChars=Number(valid.dataset.max);
   }
 }

 if(len>10){
   notice.textContent="Für diesen Text wird mindestens L empfohlen.";
   notice.classList.add("show");
 }else if(len>6){
   notice.textContent="S ist für diesen Text zu klein.";
   notice.classList.add("show");
 }else{
   notice.classList.remove("show");
 }
}

function estimateBoard(){
 const v=state.mode==="logo" ? logoDimensions() : vectorDimensions();
 let h=v.h;
 if(state.board==="rectangle"||state.board==="box"||state.board==="stand") h*=1.18;
 return {w:v.w,h:Math.round(h*10)/10};
}

function setBoardColor(){
 let fill="#ffffff18", border="#ffffff2c", contour="rgba(235,235,235,.25)", strip="#eef2f024";
 if(state.boardColor==="black"){fill="#070707dc";border="#ffffff1e";contour="rgba(8,8,8,.82)";strip="#080808d9"}
 if(state.boardColor==="white"){fill="#f7f7f7de";border="#ffffff70";contour="rgba(248,248,248,.86)";strip="#f7f7f7df"}
 if(state.boardColor==="gold"){fill="linear-gradient(135deg,#6f5222,#d7b869,#806024)";border="#d9bd78";contour="#c9a857";strip="#b99745"}
 if(state.boardColor==="silver"){fill="linear-gradient(135deg,#565656,#d6d6d6,#6c6c6c)";border="#d9d9d9";contour="#bfc1c4";strip="#bfc1c4"}
 if(state.boardColor==="ral"){fill=state.ralHex+"e0";border=state.ralHex;contour=state.ralHex;strip=state.ralHex+"e0"}

 if(state.board==="strips"){
   board.style.background=`linear-gradient(90deg,
     transparent 0 12%,${strip} 12% 16%,transparent 16% 42%,
     ${strip} 42% 46%,transparent 46% 72%,${strip} 72% 76%,transparent 76%)`;
   board.style.borderColor="transparent";
 }else{
   board.style.background=fill;
   board.style.borderColor=border;
 }

 qa(".board-line").forEach(el=>{
   el.style.webkitTextStrokeColor=contour;
   el.style.textStrokeColor=contour;
 });
}



function svgTextGeometry(){
 const NS="http://www.w3.org/2000/svg";
 measureSvg.innerHTML="";
 measureSvg.setAttribute("viewBox","0 0 2000 2000");

 const fontSize=100;
 const gap=fontSize*(state.lineSpacing/100);
 const results=[];
 let baseline=fontSize;
 let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;

 state.lines.forEach((line,i)=>{
   const text=document.createElementNS(NS,"text");
   text.setAttribute("x","0");
   text.setAttribute("y",String(baseline));
   text.setAttribute("font-size",String(fontSize));
   text.setAttribute("font-family",state.font.replace(/^['"]|['"]$/g,""));
   text.setAttribute("xml:space","preserve");
   text.textContent=line || " ";
   measureSvg.appendChild(text);

   // getBBox measures the actual SVG glyph envelope for the loaded font.
   const box=text.getBBox();
   results.push({
     index:i,
     text:line||"",
     x:box.x,y:box.y,w:Math.max(box.width,.01),h:Math.max(box.height,.01),
     baseline
   });

   minX=Math.min(minX,box.x);
   minY=Math.min(minY,box.y);
   maxX=Math.max(maxX,box.x+box.width);
   maxY=Math.max(maxY,box.y+box.height);
   baseline += fontSize + gap;
 });

 if(!Number.isFinite(minX)){
   return {fontSize,rawW:1,rawH:1,minX:0,minY:0,maxX:1,maxY:1,lines:[]};
 }

 return {
   fontSize,
   rawW:Math.max(maxX-minX,.01),
   rawH:Math.max(maxY-minY,.01),
   minX,minY,maxX,maxY,
   lines:results
 };
}

function vectorDimensions(){
 const g=svgTextGeometry();

 // The selected size is the true luminous width.
 const cmPerSvg=state.size/g.rawW;

 const lines=g.lines.map(l=>({
   index:l.index,
   text:l.text,
   w:Math.round(l.w*cmPerSvg*10)/10,
   h:Math.round(l.h*cmPerSvg*10)/10
 }));

 return {
   w:Math.round(state.size*10)/10,
   h:Math.round(g.rawH*cmPerSvg*10)/10,
   lines,
   geometry:g,
   cmPerSvg
 };
}

function svgEscapeText(value){
 return String(value||"")
   .replace(/&/g,"&amp;")
   .replace(/</g,"&lt;")
   .replace(/>/g,"&gt;")
   .replace(/"/g,"&quot;");
}

function svgColor(){
 if(state.colorMode==="rgb"||state.colorMode==="smart") return "#ffffff";
 if(state.colorMode==="multi") return "#ffffff";
 return state.core || "#fff3df";
}

function createExportSvg(){
 const light=state.mode==="logo"?logoDimensions():vectorDimensions();
 const acrylic=measureAcrylicDimensions(light);
 const outW=acrylic ? acrylic.w : light.w;
 const outH=acrylic ? acrylic.h : light.h;
 const marginX=acrylic ? (acrylic.w-light.w)/2 : 0;
 const marginY=acrylic ? (acrylic.h-light.h)/2 : 0;

 // Work in millimetres so the exported SVG carries useful physical dimensions.
 const W=outW*10, H=outH*10;

 if(state.mode==="logo"){
   const mx=acrylic?(acrylic.w-light.w)/2:0;
   const my=acrylic?(acrylic.h-light.h)/2:0;
   let backing="";
   if(state.board==="rectangle"){
     backing=`<rect x="0.5" y="0.5" width="${(W-1).toFixed(2)}" height="${(H-1).toFixed(2)}" rx="2" fill="none" stroke="#888" stroke-width="0.5"/>`;
   }
   const img=state.logoData
     ? `<image href="${state.logoData}" x="${(mx*10).toFixed(2)}" y="${(my*10).toFixed(2)}" width="${(light.w*10).toFixed(2)}" height="${(light.h*10).toFixed(2)}" preserveAspectRatio="xMidYMid meet"/>`
     : "";
   return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${outW.toFixed(1)}cm" height="${outH.toFixed(1)}cm" viewBox="0 0 ${W.toFixed(2)} ${H.toFixed(2)}">
<title>${svgEscapeText(state.logoName||"Logo")}</title>
<desc>Logo ${light.w} × ${light.h} cm${acrylic?`, Acryl ${acrylic.w} × ${acrylic.h} cm`:""}</desc>
${backing}${img}
</svg>`;
 }
 const lightW=light.w*10;
 const scale=lightW/light.geometry.rawW;
 const fontSize=light.geometry.fontSize*scale;
 const gap=fontSize*(state.lineSpacing/100);

 const fontFamily=state.fontName || state.font;
 const core=svgColor();
 let body="";

 // Backing preview.
 if(state.board==="rectangle"){
   body += `<rect x="0.5" y="0.5" width="${(W-1).toFixed(2)}" height="${(H-1).toFixed(2)}" rx="2" fill="none" stroke="#888" stroke-width="0.5"/>`;
 }else if(state.board==="strips"){
   const xs=[.18,.48,.78];
   xs.forEach(p=>{
     const x=W*p;
     body += `<rect x="${(x-2).toFixed(2)}" y="0" width="4" height="${H.toFixed(2)}" fill="none" stroke="#999" stroke-width="0.5"/>`;
   });
 }

 // Text is still vector text, not outline paths.
 // Translate by the measured glyph bounds so the actual visible geometry fits the physical box.
 const tx=marginX*10 - light.geometry.minX*scale;
 const ty=marginY*10 - light.geometry.minY*scale;

 body += `<g transform="translate(${tx.toFixed(3)} ${ty.toFixed(3)})" fill="${core}" font-family="${svgEscapeText(fontFamily)}" font-size="${fontSize.toFixed(3)}">`;

 light.geometry.lines.forEach((line,i)=>{
   const y=(line.baseline-light.geometry.minY)*scale;
   body += `<text x="0" y="${y.toFixed(3)}" xml:space="preserve">${svgEscapeText(line.text||" ")}</text>`;
 });
 body += `</g>`;

 // Tight contour backing represented as stroked SVG text.
 if(state.board==="contour"){
   const strokeMm=Math.max(1.2,Math.min(2.5,light.w*.025))*10;
   let contour=`<g transform="translate(${tx.toFixed(3)} ${ty.toFixed(3)})" fill="none" stroke="#999" stroke-width="${strokeMm.toFixed(2)}" stroke-linejoin="round" paint-order="stroke" font-family="${svgEscapeText(fontFamily)}" font-size="${fontSize.toFixed(3)}">`;
   light.geometry.lines.forEach(line=>{
     const y=(line.baseline-light.geometry.minY)*scale;
     contour += `<text x="0" y="${y.toFixed(3)}" xml:space="preserve">${svgEscapeText(line.text||" ")}</text>`;
   });
   contour += `</g>`;
   body = contour + body;
 }

 const meta=`Text: ${state.lines.join(" / ")} | Leuchtmass: ${light.w} × ${light.h} cm | ${acrylic?`Acryl: ${acrylic.w} × ${acrylic.h} cm`:"ohne Rückwand"} | Schrift: ${state.fontName}`;

 return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg"
 width="${outW.toFixed(1)}cm" height="${outH.toFixed(1)}cm"
 viewBox="0 0 ${W.toFixed(2)} ${H.toFixed(2)}">
 <title>${svgEscapeText(state.lines.join(" / "))}</title>
 <desc>${svgEscapeText(meta)}. Vektortext – Schrift vor Produktion in Pfade umwandeln.</desc>
 ${body}
</svg>`;
}

function exportSvgFile(){
 const svg=createExportSvg();
 const blob=new Blob([svg],{type:"image/svg+xml;charset=utf-8"});
 const url=URL.createObjectURL(blob);
 const a=document.createElement("a");
 const safe=((state.mode==="logo"?state.logoName.replace(/\.[^.]+$/,""):state.lines.join("-"))||"neon").replace(/[^a-z0-9äöüß_-]+/gi,"-").replace(/-+/g,"-");
 a.href=url;
 a.download=`${safe}-${state.size}cm.svg`;
 document.body.appendChild(a);
 a.click();
 a.remove();
 setTimeout(()=>URL.revokeObjectURL(url),1000);
}

function measureDimensions(){
 return state.mode==="logo" ? logoDimensions() : vectorDimensions();
}


function measureAcrylicDimensions(light){
 if(state.board==="none") return null;

 // Manufacturing preview margin:
 // contour = tight edge around the lettering
 // rectangle/box/stand = more generous panel margin
 // strips = small envelope margin
 let side=0, top=0;

 if(state.board==="contour"){
   side=Math.max(1.2,Math.min(2.5,light.w*.025));
   top=Math.max(1.2,Math.min(2.5,light.w*.025));
 }else if(state.board==="strips"){
   side=Math.max(1.5,Math.min(3.0,light.w*.03));
   top=Math.max(1.0,Math.min(2.2,light.w*.02));
 }else{
   side=Math.max(2.5,Math.min(5.0,light.w*.05));
   top=Math.max(2.5,Math.min(5.0,light.w*.05));
 }

 return {
   w:Math.round((light.w+side*2)*10)/10,
   h:Math.round((light.h+top*2)*10)/10,
   side:Math.round(side*10)/10,
   top:Math.round(top*10)/10
 };
}

function updateMeasurements(){
 const light=measureDimensions();
 const acrylic=measureAcrylicDimensions(light);

 q("#measureLight").textContent=light.w+" × "+light.h+" cm";
 q("#measureWidth").textContent=light.w+" cm";

 if(acrylic){
   q("#measureAcrylic").textContent=acrylic.w+" × "+acrylic.h+" cm";
   q("#dimensions").innerHTML="Leucht SVG "+light.w+" × "+light.h+" cm<br>Acryl ca. "+acrylic.w+" × "+acrylic.h+" cm";
 }else{
   q("#measureAcrylic").textContent="keine Rückwand";
   q("#dimensions").innerHTML="Leucht SVG "+light.w+" × "+light.h+" cm<br>ohne Rückwand";
 }

 q("#measureLines").innerHTML=state.mode==="logo"
   ? `<div class="measure-line"><span>Logo</span><b>${light.w} × ${light.h} cm</b></div>`
   : light.lines.map((l,i)=>`<div class="measure-line"><span>Zeile ${i+1}: ${l.text||"–"}</span><b>SVG ${l.w} × ${l.h} cm</b></div>`).join("");
}


function updateStageBounds(){
 // Reset to the normal stage for brick/concrete.
 if(state.bg!=="warm"){
   ["left","right","top","width","height","padding"].forEach(p=>stage.style.removeProperty(p));
   return;
 }

 const scene=q("#scene");
 const sw=scene.clientWidth;
 const sh=scene.clientHeight;

 // Source photo geometry.
 const iw=2048, ih=1366;
 const cx=1020, cy=698, radius=395;

 // background-size: cover with centered positioning.
 const scale=Math.max(sw/iw,sh/ih);
 const rw=iw*scale, rh=ih*scale;
 const ox=(sw-rw)/2;
 const oy=(sh-rh)/2;

 const pcx=ox+cx*scale;
 const pcy=oy+cy*scale;
 const pr=radius*scale;

 // Safe rectangle inscribed in the circular recess.
 // Corners remain inside the circle and leave extra room for the neon glow.
 // Wide rectangle inscribed in the circular niche.
 // This uses almost the full visually usable width while keeping the corners inside the circle.
 let safeW=pr*1.74;
 let safeH=pr*.92;

 safeW=Math.min(safeW,sw-24);
 safeH=Math.min(safeH,sh-24);

 let left=pcx-safeW/2;
 let top=pcy-safeH/2;

 left=Math.max(12,Math.min(sw-safeW-12,left));
 top=Math.max(12,Math.min(sh-safeH-12,top));

 stage.style.left=Math.round(left)+"px";
 stage.style.right="auto";
 stage.style.top=Math.round(top)+"px";
 stage.style.width=Math.round(safeW)+"px";
 stage.style.height=Math.round(safeH)+"px";
 stage.style.padding="10px";
}


function updateDimensionOverlay(){
 const light=measureDimensions();
 const stageRect=stage.getBoundingClientRect();
 const neonRect=activeVisualRect();

 if(!stageRect.width || !stageRect.height || !neonRect.width || !neonRect.height){
   dimOverlay.style.display="none";
   return;
 }

 dimOverlay.style.display="block";

 // Position relative to the actual rendered neon.
 const left=neonRect.left-stageRect.left;
 const top=neonRect.top-stageRect.top;
 const width=neonRect.width;
 const height=neonRect.height;

 // Horizontal dimension line below the lettering.
 // Keep it close enough to read as part of the sign but outside the glow.
 const hOffset=Math.max(16,Math.min(28,height*.24));
 dimWidth.style.left=Math.round(left)+"px";
 dimWidth.style.top=Math.round(top+height+hOffset)+"px";
 dimWidth.style.width=Math.round(width)+"px";
 dimWidth.style.height="18px";

 // Vertical dimension line left of the lettering.
 const vOffset=Math.max(18,Math.min(30,width*.05));
 dimHeight.style.left=Math.round(left-vOffset)+"px";
 dimHeight.style.top=Math.round(top)+"px";
 dimHeight.style.width="18px";
 dimHeight.style.height=Math.round(height)+"px";

 dimWidthLabel.textContent=light.w+" cm";
 dimHeightLabel.textContent=light.h+" cm";
}


function updateMountHardware(){
 const stageRect=stage.getBoundingClientRect();
 const neonRect=activeVisualRect();
 if(!stageRect.width || !neonRect.width)return;

 const left=neonRect.left-stageRect.left;
 const top=neonRect.top-stageRect.top;
 const width=neonRect.width;
 const height=neonRect.height;

 const chains=Array.from(mountHardware.querySelectorAll(".hw-chain"));
 const feet=Array.from(mountHardware.querySelectorAll(".hw-foot"));
 const spacers=Array.from(mountHardware.querySelectorAll(".hw-spacer"));

 chains.forEach(x=>{x.style.display="";x.style.height="0"});
 feet.forEach(x=>{x.style.display=""});
 spacers.forEach(x=>x.classList.remove("show"));

 if(state.mount==="chain"){
   const xs=[left,left+width];
   chains.forEach((el,i)=>{
     el.style.left=Math.round(xs[i])+"px";
     el.style.top="0px";
     el.style.height=Math.max(10,Math.round(top-4))+"px";
   });
 }

 if(state.mount==="table"){
   const y=top+height+6;
   const xs=[left+width*.22,left+width*.78];
   feet.forEach((el,i)=>{
     el.style.left=Math.round(xs[i]-11)+"px";
     el.style.top=Math.round(y)+"px";
   });
 }

 if(state.mount==="wall" && state.board!=="none" && state.board!=="contour"){
   const points=[
     [left+8,top+8],
     [left+width-14,top+8],
     [left+8,top+height-14],
     [left+width-14,top+height-14]
   ];
   spacers.forEach((el,i)=>{
     el.classList.add("show");
     el.style.left=Math.round(points[i][0])+"px";
     el.style.top=Math.round(points[i][1])+"px";
   });
 }
}

function updateRealisticLighting(fontPx){
 const stroke=Math.max(.35,Math.min(1.15,fontPx*.009));
 document.documentElement.style.setProperty("--tube-stroke",stroke.toFixed(2)+"px");

 // Stronger reflection on darker/material-rich walls, softer in the bright living room.
 const base=state.bg==="warm"?.38:state.bg==="brick"?.60:.52;
 const mountFactor=state.mount==="tape"?.72:state.mount==="table"?.76:state.mount==="chain"?.88:1;
 wallGlow.style.opacity=(base*mountFactor*(state.brightness/100)).toFixed(3);

 updateMountHardware();
}

function syncControlSelection(){
 const smartColor=state.colorMode==='smart';
 qa('[data-remote]').forEach(el=>{const selected=!smartColor&&!state.smart&&el.dataset.remote==='yes';el.classList.toggle('active',selected);el.setAttribute('aria-pressed',String(selected));});
 qa('[data-smart]').forEach(el=>{const selected=!smartColor&&el.dataset.smart===state.smart;el.classList.toggle('active',selected);el.setAttribute('aria-pressed',String(selected));});
 q('#remoteLabel').textContent=smartColor?'Smart Color Controller':state.smart==='tuya'?'Smart / Tuya':state.smart==='dali'?'DALI':'Remote + Dimmer';
 q('#dimmer').disabled=smartColor||!!state.smart;
 q('#dimmerWrap').classList.toggle('disabled',smartColor||!!state.smart);
}
function previewSignWidth(stageWidth){
 if(state.bg==='detail')return stageWidth*.84;
 if(state.bg==='brick'||state.bg==='concrete'){
   const scene=q('#scene'),brick=state.bg==='brick';
   // Approximate physical calibration: 23cm bricks / 300cm concrete rear wall.
   // Cover scaling must be included, especially in narrow mobile scenes.
   const scale=Math.max(scene.clientWidth/(brick?1080:800),scene.clientHeight/(brick?720:600));
   const pixelsPerCm=(brick?25/23:450/300)*scale;
   return Math.min(stageWidth*.90,state.size*pixelsPerCm);
 }
 return stageWidth*Math.max(.10,Math.min(.90,state.size/160));
}

function fitText(){
 updateStageBounds();
 const stageW=Math.max(stage.clientWidth-20,120);
 const stageH=Math.max(stage.clientHeight-20,100);

 if(state.mode==="logo"){
   const signW=previewSignWidth(stageW);

   const aspect=Math.max(.10,state.logoAspect||2.4);
   let targetW=signW*.88;
   let targetH=targetW/aspect;
   const maxH=stageH*(state.bg==='detail'?.78:.80);
   if(targetH>maxH){const k=maxH/targetH;targetW*=k;targetH*=k}

   logoPreviewWrap.style.width=Math.round(targetW)+"px";
   logoPreviewWrap.style.height=Math.round(Math.max(1,targetH))+"px";
   logoPreview.style.width="100%";
   logoPreview.style.height="100%";
   logoContourPreview.style.width="100%";
   logoContourPreview.style.height="100%";

   logoPlaceholder.style.display=state.logoData?"none":"grid";
   logoPreview.style.display=state.logoData?"block":"none";
   logoPreviewWrap.classList.toggle("neon-logo",state.logoStyle==="neon");
   logoPreviewWrap.classList.toggle("original-logo",state.logoStyle==="original");
   logoPreviewWrap.classList.toggle("logo-contour-on",state.logoData && state.board==="contour");

   if(state.board!=="none" && state.board!=="contour"){
     const d=measureDimensions();
     const acrylic=measureAcrylicDimensions(d);
     const visualH=Math.max(1,targetH);
     const pxPerCm=targetW/Math.max(.1,d.w);
     const marginWPx=acrylic?acrylic.side*pxPerCm:targetW*.04;
     const marginHPx=acrylic?acrylic.top*pxPerCm:visualH*.04;
     board.style.width=Math.round(targetW+marginWPx*2)+"px";
     board.style.height=Math.round(visualH+marginHPx*2)+"px";
   }else if(state.board==="contour"){
     board.style.width="auto";board.style.height="auto";
   }

   updateMeasurements();
   updateDimensionOverlay();
   updateMountHardware();
   return;
 }

 const signW=previewSignWidth(stageW);
 const signH=Math.min(stageH*.74, signW*.72);

 neon.style.transform="none";
 const neonLines=qa(".neon-line");
 const auraLines=qa(".wall-glow-line");
 const contourLines=qa(".board-line");

 // Reset styles before measuring.
 neonLines.forEach(el=>{
   el.style.fontFamily=state.font;
   el.style.fontSize="80px";
 });
 auraLines.forEach(el=>{
   el.style.fontFamily=state.font;
   el.style.fontSize="80px";
 });
 contourLines.forEach(el=>{
   el.style.fontFamily=state.font;
   el.style.fontSize="80px";
 });

 let targetW=signW*.88;
 let targetH=signH*.84;

 // The niche is the hard boundary in the living room.
 // Reserve only a small glow margin; do not shrink the sign a second time.
 if(state.bg==="warm"){
   targetW=Math.min(targetW,stageW*.92);
   targetH=Math.min(targetH,stageH*.80);
 }

 // Search a common font size that keeps all lines inside both width and total height.
 let low=10,high=250,best=low;
 for(let i=0;i<15;i++){
   const mid=(low+high)/2;
   neonLines.forEach(el=>el.style.fontSize=mid+"px");
   auraLines.forEach(el=>el.style.fontSize=mid+"px");
   void neon.offsetWidth;

   const widths=neonLines.map(el=>el.getBoundingClientRect().width);
   const totalHeight=neon.getBoundingClientRect().height;
   const maxWidth=Math.max(...widths,1);

   if(maxWidth<=targetW && totalHeight<=targetH){
     best=mid;low=mid;
   }else high=mid;
 }

 best*=.90;
 neonLines.forEach(el=>el.style.fontSize=Math.max(10,Math.floor(best))+"px");
 auraLines.forEach(el=>el.style.fontSize=Math.max(10,Math.floor(best))+"px");
 contourLines.forEach(el=>el.style.fontSize=Math.max(10,Math.floor(best))+"px");

 const stroke=Math.max(6,Math.min(14,Math.round(best*.11)));
 contourLines.forEach(el=>{
   el.style.webkitTextStrokeWidth=stroke+"px";
   el.style.textStrokeWidth=stroke+"px";
 });

 // Non-contour backing hugs the actual rendered text, not the full slot width.
 const dims=measureDimensions();
 if(state.board!=="none" && state.board!=="contour"){
   const acrylic=measureAcrylicDimensions(dims);
   const actualRect=neon.getBoundingClientRect();
   const actualW=actualRect.width||signW*.6;
   const actualH=actualRect.height||actualW*(dims.h/Math.max(.1,dims.w));
   const pxPerCm=actualW/Math.max(.1,dims.w);
   const marginWPx=acrylic?acrylic.side*pxPerCm:actualW*.05;
   const marginHPx=acrylic?acrylic.top*pxPerCm:actualH*.05;
   board.style.width=Math.round(actualW+marginWPx*2)+"px";
   board.style.height=Math.round(actualH+marginHPx*2)+"px";
 }

 if(state.board==="contour"){
   board.style.width="auto";
   board.style.height="auto";
 }

 updateMeasurements();
 updateDimensionOverlay();
 updateRealisticLighting(best);
}


function labelBoard(){
 return {
   none:"Freigestellt",
   contour:"Kontur",
   rectangle:"Rechteck",
   strips:"Acrylstreben",
   box:"Acrylbox",
   stand:"Aufsteller"
 }[state.board]||state.board;
}

function labelBoardColor(){
 return {
   transparent:"Transparent",
   black:"Schwarz",
   white:"Weiss",
   gold:"Gold",
   silver:"Silber",
   ral:state.ral||"RAL"
 }[state.boardColor]||state.boardColor;
}

function labelMount(){
 return {
   wall:"Wandmontage",
   chain:"Kettenaufhängung",
   tape:"3M Klebestreifen",
   table:"Tischständer"
 }[state.mount]||state.mount;
}

function buildConfigPayload(){
 const p=price();
 const light=measureDimensions();
 const acrylic=measureAcrylicDimensions(light);
 const commerce=commerceStatus();

 return {
   version:"neon-pricing-2026-10-18",
   production:{express:q("#expressProduction").checked},
   created_at:new Date().toISOString(),
   commerce_mode:commerce.mode,
   quote_reasons:commerce.reasons,
   product_mode:state.mode,
   content:state.mode==="logo"
     ? {logo_name:state.logoName,logo_format:state.logoFormat,logo_aspect:state.logoAspect,logo_style:state.logoStyle}
     : {lines:[...state.lines],font:state.fontName,line_spacing_percent:state.lineSpacing},
   size:{mode:state.sizeMode,width_cm:state.size},
   dimensions:{
     light_width_cm:light.w,
     light_height_cm:light.h,
     acrylic_width_cm:acrylic?acrylic.w:null,
     acrylic_height_cm:acrylic?acrylic.h:null
   },
   light:{
     color:state.colorName,
     color_mode:state.colorMode,
     brightness_percent:state.brightness
   },
   backing:{
     form:state.board,
     form_label:labelBoard(),
     color:state.boardColor,
     color_label:labelBoardColor()
   },
   mounting:{type:state.mount,label:labelMount()},
   control:{
      remote:state.colorMode==="smart"?false:state.remote,
      smart:state.smart||null,
      smart_color_controller:state.colorMode==="smart",
      custom_modes:state.colorMode==="smart"?Number(q("#customModes").value):0
    },
   environment:state.use,
   preview_background:state.bg,
   price:{
     currency:"CHF",
     retail:p.retail,
     shopify_variant_price_cents:SHOPIFY.variantPriceCents||null
   },
   shopify:{
     checkout_mode:SHOPIFY.checkoutMode,
     variant_id:SHOPIFY.variantId||null
   }
 };
}

function updateCheckoutSummary(){
 const p=price();
 const light=measureDimensions();
 const acrylic=measureAcrylicDimensions(light);
 const commerce=commerceStatus();

 const title=state.mode==="logo"
   ? (state.logoName||"Eigenes Logo")
   : (state.lines.join(" / ")||"DEIN NEON");

 q("#checkoutTitle").textContent=title;

 const rows=[
   ["Produkt",state.mode==="logo"?"Eigenes Logo":"Neonschrift"],
   ...(state.mode==="text"?[["Schrift",state.fontName]]:[]),
   ["Grösse",(state.sizeMode==="manual"?"Manuell · ":"")+state.size+" cm"],
   ["Leuchtmass",light.w+" × "+light.h+" cm"],
   ["Acrylmass",acrylic?(acrylic.w+" × "+acrylic.h+" cm"):"ohne Rückwand"],
   ["Lichtfarbe",state.colorName],
   ["Rückwand",labelBoard()],
   ...((state.board==="rectangle"||state.board==="strips")?[["Rückwandfarbe",labelBoardColor()]]:[]),
   ["Montage",labelMount()],
   ["Steuerung",state.colorMode==="smart"?"Smart Color Controller":state.smart?(state.smart==="tuya"?"Smart / Tuya":"DALI"):"Remote + Dimmer"],
   ["Einsatz",state.use==="indoor"?"Innen":"Aussen"],
   ...(state.colorMode==="smart"?[["Smart Color-Modi",Number(q("#customModes").value)===0?"Standardmodi":Number(q("#customModes").value)===1?"Standardmodi + 1 eigener Modus":"Mehrere eigene Modi (Offerte)"]]:[]),
   ["Produktion",q("#expressProduction").checked?"Express 2–3 Tage":"Standard 5–7 Tage"]
 ];

 q("#checkoutSummary").innerHTML=rows.map(r=>`<div class="summary-row"><span>${r[0]}</span><b>${r[1]}</b></div>`).join("");

 const badge=q("#commerceBadge");
 badge.className="commerce-badge "+commerce.mode;
 badge.textContent=commerce.mode==="order"?"BESTELLBAR":commerce.mode==="quote"?"OFFERTANFRAGE":"NOCH NICHT BEREIT";

 const btn=q("#commerceBtn");
 btn.disabled=commerce.mode==="blocked";

 if(commerce.mode==="order"){
   if(SHOPIFY.checkoutMode==="draft_order"){
     const dynamicPrice=p.retail!==null ? "CHF "+p.retail+".–" : "";
     q("#priceCaption").textContent="Preis ohne MwSt.";
     q("#priceNote").textContent="Lieferung inklusive; Import/Zoll separat (DAP)";
     btn.textContent="ZUM CHECKOUT"+(dynamicPrice?" · "+dynamicPrice:"");
   }else{
     const shopPrice=SHOPIFY.variantPriceFormatted||"";
     if(shopPrice){
       q("#price").textContent=shopPrice;
       q("#priceCaption").textContent="Shopify-Preis";
       q("#priceNote").innerHTML="Preis des gewählten<br>Shopify-Produkts";
     }
     btn.textContent="IN DEN WARENKORB"+(shopPrice?" · "+shopPrice:"");
   }
   q("#inquiryPanel").style.display="none";
 }else if(commerce.mode==="quote"){
   btn.textContent="OFFERTE ANFRAGEN";
   q("#priceCaption").textContent="Preis";
 }else{
   btn.textContent="PREIS WIRD BERECHNET …";
   q("#inquiryPanel").style.display="none";
 }

 if(commerce.mode==="quote"){
   q("#priceNote").innerHTML=commerce.reasons.slice(0,2).join("<br>");
 }
}

function downloadConfigJson(payload){
 const text=JSON.stringify(payload||buildConfigPayload(),null,2);
 const blob=new Blob([text],{type:"application/json;charset=utf-8"});
 const url=URL.createObjectURL(blob);
 const a=document.createElement("a");
 const name=(state.mode==="logo"?(state.logoName||"logo").replace(/\.[^.]+$/,""):state.lines.join("-")||"neon")
   .replace(/[^a-z0-9äöüß_-]+/gi,"-").replace(/-+/g,"-");
 a.href=url;
 a.download=name+"-konfiguration.json";
 document.body.appendChild(a);
 a.click();
 a.remove();
 setTimeout(()=>URL.revokeObjectURL(url),1000);
}

async function triggerCommerceAction(){
 const status=commerceStatus();
 const payload=buildConfigPayload();

 if(status.mode==="blocked"){
   const toast=q("#toast");
   toast.textContent=status.reasons[0]||"Konfiguration noch nicht vollständig.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),2000);
   return;
 }

 if(status.mode==="quote"){
   q("#inquiryPanel").style.display="";
   q("#inquiryPanel").scrollIntoView({behavior:"smooth",block:"nearest"});
   return;
 }

 const btn=q("#commerceBtn");
 const oldText=btn.textContent;
 btn.disabled=true;

 // Dynamic checkout: authoritative server-side price + Shopify Draft Order.
 if(SHOPIFY.checkoutMode==="draft_order"){
   btn.textContent="CHECKOUT WIRD ERSTELLT …";
   try{
     const response=await fetch(SHOPIFY.draftOrderEndpoint,{
       method:"POST",
       headers:{"Content-Type":"application/json","Accept":"application/json"},
       body:JSON.stringify({configuration:payload})
     });

     const data=await response.json().catch(()=>({}));
     if(!response.ok){
       throw new Error(data.error||data.message||"Checkout konnte nicht erstellt werden.");
     }
     if(!data.checkoutUrl){
       throw new Error("Shopify hat keine Checkout-URL zurückgegeben.");
     }

     window.__NEON_DRAFT_ORDER__=data;
     window.dispatchEvent(new CustomEvent("neon-configurator:draft-order",{detail:data}));
     window.location.href=data.checkoutUrl;
     return;
   }catch(err){
     const toast=q("#toast");
     toast.textContent=err&&err.message?err.message:"Fehler beim Erstellen des Checkouts.";
     toast.classList.add("show");
     setTimeout(()=>toast.classList.remove("show"),3500);
   }finally{
     btn.disabled=false;
     btn.textContent=oldText;
   }
   return;
 }

 // Native Shopify cart mode.
 if(!SHOPIFY.variantId){
   const toast=q("#toast");
   toast.textContent="Im Theme-Editor ist noch kein Shopify-Produkt ausgewählt.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),2400);
   btn.disabled=false;
   return;
 }

 btn.textContent="WIRD HINZUGEFÜGT …";

 try{
   const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
   const light=measureDimensions();
   const acrylic=measureAcrylicDimensions(light);

   const props={
     "Konfiguration":state.mode==="logo"?(state.logoName||"Eigenes Logo"):state.lines.join(" / "),
     "Schrift":state.mode==="text"?state.fontName:"–",
     "Grösse":(state.sizeMode==="manual"?"Manuell · ":"")+state.size+" cm",
     "Leuchtmass":light.w+" × "+light.h+" cm",
     "Acrylmass":acrylic?(acrylic.w+" × "+acrylic.h+" cm"):"ohne Rückwand",
     "Lichtfarbe":state.colorName,
     "Rückwand":labelBoard(),
     "Rückwandfarbe":(state.board==="rectangle"||state.board==="strips")?labelBoardColor():"–",
     "Montage":labelMount(),
     "Steuerung":state.colorMode==="smart"?"Smart Color Controller":state.smart?(state.smart==="tuya"?"Smart / Tuya":"DALI"):"Remote + Dimmer",
     "Einsatz":state.use==="indoor"?"Innen":"Aussen",
     "_Neon_Config":JSON.stringify(payload)
   };

   const response=await fetch(root+"cart/add.js",{
     method:"POST",
     headers:{"Content-Type":"application/json","Accept":"application/json"},
     body:JSON.stringify({
       items:[{id:Number(SHOPIFY.variantId),quantity:1,properties:props}]
     })
   });

   const data=await response.json();
   if(!response.ok) throw new Error(data.description||data.message||"Warenkorb konnte nicht aktualisiert werden.");

   window.__NEON_CART_ITEM__=payload;
   window.dispatchEvent(new CustomEvent("neon-configurator:add-to-cart",{detail:payload}));

   if(SHOPIFY.afterAdd==="cart"){
     window.location.href=SHOPIFY.cartUrl||root+"cart";
     return;
   }

   const toast=q("#toast");
   toast.textContent="Neon wurde dem Warenkorb hinzugefügt.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),2200);
 }catch(err){
   const toast=q("#toast");
   toast.textContent=err&&err.message?err.message:"Fehler beim Hinzufügen zum Warenkorb.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),3000);
 }finally{
   btn.disabled=false;
   btn.textContent=oldText;
 }
}

let quoteKey='',quoteResult=null,quoteTimer=null,quoteSequence=0;
function characterLimitReason(){
 const limit={30:6,50:10,80:16}[state.size]??16;
 return state.mode==='text'&&cleanLen()>limit?`Diese Grösse erlaubt maximal ${limit} Zeichen. Bitte eine individuelle Offerte anfragen.`:'';
}
function currentPriceConfiguration(){
 const light=measureDimensions();
 const acrylic=measureAcrylicDimensions(light);
 return {version:'neon-pricing-2026-10-18',product_mode:state.mode,
 content:{lines:[...state.lines],font:state.fontName,line_spacing_percent:state.lineSpacing},
 size:{mode:state.sizeMode,width_cm:state.size},
 dimensions:{light_width_cm:light.w,light_height_cm:light.h,acrylic_width_cm:acrylic?acrylic.w:null,acrylic_height_cm:acrylic?acrylic.h:null},
 light:{color_mode:state.colorMode,color:state.colorName,brightness_percent:state.brightness},
 backing:{form:state.board,form_label:labelBoard(),color:state.boardColor,color_label:labelBoardColor()},
 mounting:{type:state.mount,label:labelMount()},
 control:{remote:state.colorMode==='smart'?false:state.remote,smart:state.smart||null,smart_color_controller:state.colorMode==='smart',custom_modes:state.colorMode==='smart'?Number(q('#customModes').value):0},
 environment:state.use,production:{express:q('#expressProduction').checked}};
}
function requestPrice(){
 const configuration=currentPriceConfiguration(),key=JSON.stringify(configuration);
 if(key===quoteKey)return;
 quoteKey=key;quoteResult=null;
 clearTimeout(quoteTimer);
 const sequence=++quoteSequence;
 if(characterLimitReason()){
  quoteResult={amount:null,quoteRequired:true,reasons:[characterLimitReason()]};return;
 }
 quoteTimer=setTimeout(async()=>{
  try{
   const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
   let response;
   try{response=await fetch(SHOPIFY.draftOrderEndpoint.replace(/\/draft-order\/?$/,'/quote'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({configuration}),signal:controller.signal});}finally{clearTimeout(timeout);}
   const data=await response.json();
   if(!response.ok)throw new Error(data.error||'Preis konnte nicht berechnet werden.');
   if(sequence!==quoteSequence)return;
   quoteResult=data;
  }catch(error){if(sequence!==quoteSequence)return;quoteResult={amount:null,quoteRequired:true,reasons:[error.name==='AbortError'?'Preisberechnung derzeit nicht erreichbar.':error.message]};}
  price();updateCheckoutSummary();
 },300);
}
function price(){
 requestPrice();
 const r=quoteResult;
 q('#smartModesWrap').style.display=state.colorMode==='smart'?'':'none';
 q('#price').textContent=!r?'PREIS WIRD BERECHNET …':r.amount===null?'AUF ANFRAGE':'CHF '+r.amount+'.–';
 q('#priceCaption').textContent='Preis ohne MwSt.';
 q('#priceNote').textContent=!r?'Berechnung läuft':r.quoteRequired?(r.reasons?.[0]||'Individuelle Offerte'):'Lieferung inklusive; Import/Zoll separat (DAP)';
 q('#deliveryEstimate').textContent=q('#expressProduction').checked?'Expressproduktion 2–3 Tage; Versand 5–7 Tage.':'Produktion 5–7 Tage; Versand 5–7 Tage. Gesamtdauer ca. 13–15 Tage.';
 return {retail:r?.amount??null,total:null,b:measureAcrylicDimensions(measureDimensions())};
}
function commerceStatus(){
 if(characterLimitReason())return {mode:'quote',reasons:[characterLimitReason()]};
 const r=quoteResult;
 if(!r)return {mode:'blocked',reasons:['Preis wird berechnet']};
 if(r.quoteRequired||r.amount===null)return {mode:'quote',reasons:r.reasons||['Individuelle Offerte']};
 return {mode:'order',reasons:[]};
}

function updateBoardColorVisibility(){
 const visible=state.board==="rectangle" || state.board==="strips";
 q("#boardColorSection").style.display=visible?"":"none";

 if(!visible){
   state.boardColor="transparent";
   q("#boardColorLabel").textContent="Transparent";
   qa("[data-boardcolor]").forEach(x=>x.classList.toggle("active",x.dataset.boardcolor==="transparent"));
   q("#ralrow").classList.remove("show");
 }
 q("#boardColorSection").dataset.boardHidden=(state.board==="rectangle"||state.board==="strips")?"false":"true";
 if(wizardMedia.matches)applyWizardVisibility(false);
}

function render(){
 syncControlSelection();
 if(state.mode==="text"){
   syncLinesFromInputs();
   q("#lineCountHint").textContent=state.lines.length;
   updateLineSpacingVisibility();
   rebuildPreviewLines();
 }
 autoSize();
 setModeVisibility();
 updateLineSpacingVisibility();
 updateLogoInfo();

 neon.style.opacity=state.brightness/100;
 logoPreviewWrap.style.opacity=state.brightness/100;
 neon.classList.remove("rgbtext","multitext");
 if(state.colorMode==="rgb"||state.colorMode==="smart") neon.classList.add("rgbtext");
 else if(state.colorMode==="multi") neon.classList.add("multitext");
 else{
   document.documentElement.style.setProperty("--glow",state.glow);
   document.documentElement.style.setProperty("--core",state.core)
 }

 q("#scene").className="scene photo "+state.bg+(state.colorMode==="smart"?" smart-color":"");
 q(".fitbadge").textContent=state.bg==="detail"?"DETAILANSICHT · MASSE IN CM":"RAUMANSICHT · ILLUSTRATIVER GRÖSSENVERGLEICH";
 stage.className="stage mount-"+state.mount;
 wallGlow.className="wall-glow mode-"+state.colorMode;
 board.className="board "+({none:"none",contour:"contour",rectangle:"",strips:"strips",box:"box",stand:"stand"}[state.board]||"");
 updateBoardColorVisibility();
 boardLines.className="board-lines";
 setBoardColor();

 // font samples always show first line
 qa(".font-sample").forEach(x=>x.textContent=state.lines[0]||"DEIN NEON");

 fitText();
 price();
 setTimeout(()=>{fitText();price();updateCheckoutSummary()},80);
 setTimeout(()=>{fitText();price();updateCheckoutSummary()},250);
 setTimeout(()=>{fitText();price();updateCheckoutSummary()},700);
 updateCheckoutSummary();
 syncWizardAfterRender();
}

document.addEventListener("click",e=>{
 const helpEl=e.target.closest(".choice-help");
 if(helpEl){e.stopPropagation();openHelp(helpEl.dataset.help);return}
 if(e.target.id==="helpLightboxClose"||e.target.id==="helpLightbox"){closeHelp();return}

 const t=e.target.closest("button"); if(!t)return;

 if(t.dataset.configMode){
   setConfigMode(t.dataset.configMode);return;
 }
 if(t.dataset.logoStyle){
   qa("[data-logo-style]").forEach(x=>x.classList.remove("active"));t.classList.add("active");
   state.logoStyle=t.dataset.logoStyle;render();return;
 }

 if(t.id==="addLine"){
   syncLinesFromInputs();
   if(state.lines.length>=4)return;
   state.lines.push("");
   rebuildLinesEditor();
   render();
   const inputs=getLineInputs();
   if(inputs.length) inputs[inputs.length-1].focus();
   return;
 }

 if(t.dataset.removeLine!==undefined){
   syncLinesFromInputs();
   const i=Number(t.dataset.removeLine);
   if(state.lines.length<=1)return;
   state.lines.splice(i,1);
   rebuildLinesEditor();
   render();
   return;
 }
 if(t.classList.contains("font-card")){qa(".font-card").forEach(x=>x.classList.remove("active"));t.classList.add("active");const f=fonts[Number(t.dataset.fontIndex)];state.font=f[2];state.fontName=f[0];render();return}
 if(t.classList.contains("filter")){qa(".filter").forEach(x=>x.classList.remove("active"));t.classList.add("active");const f=t.dataset.filter;qa(".font-card").forEach(x=>x.style.display=(f==="all"||x.dataset.category===f)?"":"none");return}
 if(t.classList.contains("swatch")){qa(".swatch").forEach(x=>x.classList.remove("active"));t.classList.add("active");state.colorMode=t.dataset.mode;state.colorName=t.dataset.name;if(state.colorMode==="solid"){state.glow=t.dataset.glow;state.core=t.dataset.core}q("#colorLabel").textContent=state.colorName;render();return}
 if(t.dataset.size){
   if(t.disabled)return;
   qa("[data-size]").forEach(x=>x.classList.remove("active"));
   q("#manualSizeChoice").classList.remove("active");
   t.classList.add("active");
   state.sizeMode="preset";
   state.customSize=false;
   state.size=Number(t.dataset.size);
   state.maxChars=Number(t.dataset.max);
   q("#customSize").value="";
   q("#manualSizePanel").style.display="none";
   render();return
 }
 if(t.dataset.sizeMode==="manual"){
   qa("[data-size]").forEach(x=>x.classList.remove("active"));
   t.classList.add("active");
   state.sizeMode="manual";
   state.customSize=true;
   q("#manualSizePanel").style.display="";
   q("#customSize").focus();
   render();return
 }
 if(t.dataset.use){
   qa("[data-use]").forEach(x=>x.classList.remove("active"));t.classList.add("active");
   state.use=t.dataset.use;
   q("#useLabel").textContent=state.use==="indoor"?"Innen":"Aussen";
   render();return
 }
 if(t.dataset.board){
   qa("[data-board]").forEach(x=>x.classList.remove("active"));t.classList.add("active");
   state.board=t.dataset.board;
   q("#boardLabel").textContent=t.querySelector("b").textContent;
   updateBoardColorVisibility();
   render();return
 }
 if(t.dataset.boardcolor){qa("[data-boardcolor]").forEach(x=>x.classList.remove("active"));t.classList.add("active");state.boardColor=t.dataset.boardcolor;q("#boardColorLabel").textContent=t.querySelector("b").textContent;q("#ralrow").classList.toggle("show",state.boardColor==="ral");render();return}
 if(t.dataset.mount){qa("[data-mount]").forEach(x=>x.classList.remove("active"));t.classList.add("active");state.mount=t.dataset.mount;q("#mountLabel").textContent=t.querySelector("b").textContent;render();return}
 if(t.dataset.remote){
   state.smart=null;state.remote=true;syncControlSelection();render();return;
 }
 if(t.dataset.smart){
   state.smart=state.smart===t.dataset.smart?null:t.dataset.smart;
   state.remote=!state.smart;syncControlSelection();render();return;
 }
 if(t.classList.contains("bgbtn")){qa(".bgbtn").forEach(x=>x.classList.remove("active"));t.classList.add("active");state.bg=t.dataset.bg;render();return}
 if(t.id==="applyCustomSize"){
   const val=Math.round(Number(q("#customSize").value));
   if(!Number.isFinite(val)||val<20||val>200){
     const toast=q("#toast");
     toast.textContent="Bitte 20 bis 200 cm eingeben.";
     toast.classList.add("show");
     setTimeout(()=>toast.classList.remove("show"),2200);
     q("#customSize").focus();
     return;
   }

   // Manual means manual — even if the entered number happens to be 30, 50 or 80.
   state.sizeMode="manual";
   state.customSize=true;
   state.size=val;
   state.maxChars=999;
   qa("[data-size]").forEach(x=>x.classList.remove("active"));
   q("#manualSizeChoice").classList.add("active");
   q("#manualSizePanel").style.display="";
   render();
   return;
 }
 if(t.id==="wizardPrev"){moveWizard(-1);return}
 if(t.id==="wizardNext"){moveWizard(1);return}
 if(t.id==="commerceBtn"){
   triggerCommerceAction();
   return;
 }
 if(t.id==="downloadConfigBtn"){
   downloadConfigJson();
   return;
 }
 if(t.id==="svgExportBtn"){
   exportSvgFile();
   const toast=q("#toast");
   toast.textContent="SVG wurde erstellt.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),1800);
   return;
 }
 if(t.id==="saveBtn"){
   const payload=buildConfigPayload();
   window.__NEON_SAVED_CONFIG__=payload;
   const toast=q("#toast");
   toast.textContent="Konfiguration gespeichert.";
   toast.classList.add("show");
   setTimeout(()=>toast.classList.remove("show"),1800);
   return;
 }
});

q("#linesEditor").addEventListener("input",e=>{
 if(e.target.classList.contains("line-input")) render();
});
q("#dimmer").addEventListener("input",e=>{state.brightness=Number(e.target.value);q("#dimval").textContent=state.brightness+"%";render()});
q("#ralInput").addEventListener("input",e=>{state.ral=e.target.value});
q("#ralHex").addEventListener("input",e=>{state.ralHex=e.target.value;render()});
q("#inquiryForm").addEventListener("submit",e=>{
 const payload=buildConfigPayload();
 const status=commerceStatus();
 const light=measureDimensions();
 const acrylic=measureAcrylicDimensions(light);

 const lines=[
   "NEON-KONFIGURATOR",
   "",
   "Modus: "+(state.mode==="logo"?"Eigenes Logo":"Text"),
   "Inhalt: "+(state.mode==="logo"?(state.logoName||"Logo"):state.lines.join(" / ")),
   ...(state.mode==="text"?["Schrift: "+state.fontName]:[]),
   "Grösse: "+(state.sizeMode==="manual"?"Manuell · ":"")+state.size+" cm",
   "Leuchtmass: "+light.w+" × "+light.h+" cm",
   "Acrylmass: "+(acrylic?(acrylic.w+" × "+acrylic.h+" cm"):"ohne Rückwand"),
   "Lichtfarbe: "+state.colorName,
   "Rückwand: "+labelBoard(),
   ...((state.board==="rectangle"||state.board==="strips")?["Rückwandfarbe: "+labelBoardColor()]:[]),
   "Montage: "+labelMount(),
   "Steuerung: "+(state.colorMode==="smart"?"Smart Color Controller":state.smart?(state.smart==="tuya"?"Smart / Tuya":"DALI"):"Remote + Dimmer"),
   "Einsatz: "+(state.use==="indoor"?"Innen":"Aussen"),
   "",
   "Grund für Offerte: "+status.reasons.join(", "),
   "",
   "Konfigurationsdaten:",
   JSON.stringify(payload),
   ...(state.mode==="logo"
     ? (state.logoData?["","Logo-Datei (Base64 Data-URI, Format "+(state.logoFormat||"unbekannt")+"):",state.logoData]:[])
     : ["","Produktions-SVG (Vektortext, vor Produktion in Pfade umwandeln):",createExportSvg()])
 ];

 q("#inquiryConfigBody").value=lines.join("\n");
 window.__NEON_QUOTE_REQUEST__={
   contact:{
     name:q("#inquiryName").value.trim(),
     email:q("#inquiryEmail").value.trim(),
     company:q("#inquiryCompany").value.trim(),
     phone:q("#inquiryPhone").value.trim(),
     message:q("#inquiryMessage").value.trim()
   },
   configuration:payload
 };
});

q("#logoFile").addEventListener("change",e=>{
 const file=e.target.files&&e.target.files[0];
 handleLogoFile(file);
});
q("#lineSpacing").addEventListener("input",e=>{
 state.lineSpacing=Number(e.target.value);
 q("#spacingValue").textContent=state.lineSpacing+"%";
 render();
});
q("#customSize").addEventListener("keydown",e=>{if(e.key==="Enter"){e.preventDefault();q("#applyCustomSize").click()}});
window.addEventListener("resize",()=>{updateStageBounds();fitText();updateDimensionOverlay()});
q("#customModes").addEventListener("change",()=>{price();updateCheckoutSummary()});
q("#expressProduction").addEventListener("change",()=>{price();updateCheckoutSummary()});
if(document.fonts&&document.fonts.ready) document.fonts.ready.then(()=>{fitText();price();setTimeout(()=>{fitText();price()},120);setTimeout(()=>{fitText();price()},400);setTimeout(()=>{fitText();price()},900)});
setTimeout(fitText,80);
setTimeout(fitText,350);
setTimeout(fitText,900);

rebuildLinesEditor();
setModeVisibility();
updateLogoInfo();
render();
updateCheckoutSummary();
applyWizardVisibility(false);
window.__NEON_CONFIG_STATE__=state;
})();


